import { apiFetch } from "./client";

export interface EntraDirectoryUser {
  externalId: string;
  displayName: string;
  email: string;
  userPrincipalName: string;
}

export interface EntraDirectoryGroup {
  externalId: string;
  displayName: string;
  description: string | null;
}

export const entraSyncApi = {
  listUsers: (companyId: string) =>
    apiFetch<EntraDirectoryUser[]>(`/companies/${companyId}/entra/users`),

  listGroups: (companyId: string) =>
    apiFetch<EntraDirectoryGroup[]>(`/companies/${companyId}/entra/groups`),

  importUsers: (companyId: string, users: Array<{ externalId: string; email: string; displayName?: string }>) =>
    apiFetch(`/companies/${companyId}/entra/import-users`, {
      method: "POST",
      body: JSON.stringify({ users }),
    }),

  importGroups: (companyId: string, groups: Array<{ externalId: string; displayName: string }>) =>
    apiFetch(`/companies/${companyId}/entra/import-groups`, {
      method: "POST",
      body: JSON.stringify({ groups }),
    }),

  syncGroup: (companyId: string, groupId: string) =>
    apiFetch<{ memberCount: number }>(`/companies/${companyId}/entra/sync-group/${groupId}`, {
      method: "POST",
    }),
};
